import SendReports from "./SendReports";

export default SendReports;
